import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const TabLayout = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

TabLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default TabLayout;
